import { render, staticRenderFns } from "./UnitModuleList.vue?vue&type=template&id=1ffc3a86&scoped=true&"
import script from "./UnitModuleList.vue?vue&type=script&lang=js&"
export * from "./UnitModuleList.vue?vue&type=script&lang=js&"
import style0 from "./UnitModuleList.vue?vue&type=style&index=0&id=1ffc3a86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffc3a86",
  null
  
)

export default component.exports